import React from 'react';
import { Stepper, GetInfo } from '@operations/shared';
import BulkUploadBranchesSheet from './bulkUploadBranchesSheet'

function BulkUploadCompanyBranches() {
    const componentSteps = [
        {
            title: 'Select Company',
            content: <GetInfo apiLink='companies/getOneCompany/' isAllCompanies={true}/>,
            id: 0,
        },
        {
            title: 'Add company branches',
            content: <BulkUploadBranchesSheet />,
            id: 1,
        }
    ]
    
    return (
        <div className='bulkUpdateUserInfo'>
            <Stepper componentSteps={componentSteps} />
        </div>
    )
}

export default BulkUploadCompanyBranches